import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

export const ButtonComponent = ({
  variant,
  buttonName,
  className,
  color,
  handleClick,
  style,
  disabled
}) => {
  return (
    <Button
      variant={variant}
      className={` form-btn ${className}`}
      color={color}
      onClick={handleClick}
      style={style}
      disabled={disabled}
    >
      {buttonName}
    </Button>
  );
};

ButtonComponent.prototype = {
  variant: PropTypes.string,
  buttonName: PropTypes.string,
  className: PropTypes.any,
  color: PropTypes.any,
  handleClick: PropTypes.func,
  style: PropTypes.any,
  disabled: PropTypes.bool
};
